// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import gql from 'graphql-tag';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type GetSearchSiRnaQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ProductSearchSiRna>;
}>;


export type GetSearchSiRnaQuery = { __typename?: 'Query', getSearchSiRNA?: { __typename?: 'SearchResponseSiRNA', term?: Array<string | null> | null, count?: number | null, results?: Array<{ __typename?: 'SiRNAResults', refseqId?: string | null, siRNAType?: string | null, species?: string | null, subSetInfo?: Array<{ __typename?: 'SirnaSubSetInfo', siRNAId?: string | null, geneId?: number | null, geneSymbol?: string | null, refseqId?: string | null, species?: string | null, method?: string | null, sirnaProdType?: string | null, siRNAType?: string | null, siRNAAntiSenseSeq?: string | null, siRNASenseSeq?: string | null, fuzzyStart?: number | null, siRNATargetSeq?: string | null, fuzzyEnd?: number | null, ranking?: number | null, refseqStart?: number | null, refseqEnd?: number | null, price?: string | null, currency?: string | null, currencySymbol?: string | null, material?: string | null, brand?: string | null } | null> | null } | null> | null, serverError?: { __typename?: 'ServerError', key?: string | null, value?: string | null } | null } | null };

export type GetPriceSiRnaQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PriceInputSiRna>;
}>;


export type GetPriceSiRnaQuery = { __typename?: 'Query', getPriceSiRNA?: { __typename?: 'PriceResponseSiRNA', id?: string | null, price?: string | null, currency?: string | null, currencySymbol?: string | null, material?: string | null, serverError?: { __typename?: 'ServerError', key?: string | null, value?: string | null } | null } | null };

export type GetSemiConfSessionDataQueryVariables = Types.Exact<{
  product?: Types.InputMaybe<Types.SemiConfiguratorProductInput>;
}>;


export type GetSemiConfSessionDataQuery = { __typename?: 'Query', getSemiConfSessionData?: { __typename?: 'SemiConfSessionData', term?: Array<string | null> | null, count?: number | null, pageNo?: number | null, stepNo?: number | null, perPage?: number | null, results?: Array<{ __typename?: 'Results', refseqId?: string | null, siRNAType?: string | null, species?: string | null, subSetInfo?: Array<{ __typename?: 'SemiConfSubSetInfo', siRNAId?: string | null, geneId?: number | null, geneSymbol?: string | null, refseqId?: string | null, species?: string | null, method?: string | null, sirnaProdType?: string | null, siRNAType?: string | null, siRNAAntiSenseSeq?: string | null, siRNASenseSeq?: string | null, fuzzyStart?: number | null, siRNATargetSeq?: string | null, fuzzyEnd?: number | null, ranking?: number | null, refseqStart?: number | null, refseqEnd?: number | null, price?: string | null, currency?: string | null, currencySymbol?: string | null, material?: string | null, brand?: string | null, checked?: boolean | null } | null> | null } | null> | null, selectedItems?: Array<{ __typename?: 'Results', refseqId?: string | null, siRNAType?: string | null, species?: string | null, subSetInfo?: Array<{ __typename?: 'SemiConfSubSetInfo', siRNAId?: string | null, geneId?: number | null, geneSymbol?: string | null, refseqId?: string | null, species?: string | null, method?: string | null, sirnaProdType?: string | null, siRNAType?: string | null, siRNAAntiSenseSeq?: string | null, siRNASenseSeq?: string | null, fuzzyStart?: number | null, siRNATargetSeq?: string | null, fuzzyEnd?: number | null, ranking?: number | null, refseqStart?: number | null, refseqEnd?: number | null, price?: string | null, currency?: string | null, currencySymbol?: string | null, material?: string | null, brand?: string | null, count?: number | null, purification?: string | null, size?: string | null } | null> | null } | null> | null, serverError?: { __typename?: 'ServerError', key?: string | null, value?: string | null } | null } | null };

export type GetSubItemPriceSiRnaQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.SubItemPriceInputSiRna>;
}>;


export type GetSubItemPriceSiRnaQuery = { __typename?: 'Query', getSubItemPriceSiRNA?: { __typename?: 'SubsetItemPrice', result?: Array<{ __typename?: 'SubsetPricingInfo', siRNAId?: string | null, siRNAType?: string | null, price?: string | null, currency?: string | null, currencySymbol?: string | null, checked?: boolean | null, purification?: string | null, size?: string | null, material?: string | null } | null> | null } | null };


export const GetSearchSiRnaDocument = gql`
    query getSearchSiRNA($input: ProductSearchSiRNA) {
  getSearchSiRNA(input: $input) {
    term
    count
    results {
      refseqId
      siRNAType
      species
      subSetInfo {
        siRNAId
        geneId
        geneSymbol
        refseqId
        species
        method
        sirnaProdType
        siRNAType
        siRNAAntiSenseSeq
        siRNASenseSeq
        fuzzyStart
        siRNATargetSeq
        fuzzyEnd
        ranking
        refseqStart
        refseqEnd
        price
        currency
        currencySymbol
        material
        brand
      }
    }
    serverError {
      key
      value
    }
  }
}
    `;
export type GetSearchSiRnaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSearchSiRnaQuery, GetSearchSiRnaQueryVariables>, 'query'>;

    export const GetSearchSiRnaComponent = (props: GetSearchSiRnaComponentProps) => (
      <ApolloReactComponents.Query<GetSearchSiRnaQuery, GetSearchSiRnaQueryVariables> query={GetSearchSiRnaDocument} {...props} />
    );
    

/**
 * __useGetSearchSiRnaQuery__
 *
 * To run a query within a React component, call `useGetSearchSiRnaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchSiRnaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchSiRnaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSearchSiRnaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSearchSiRnaQuery, GetSearchSiRnaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSearchSiRnaQuery, GetSearchSiRnaQueryVariables>(GetSearchSiRnaDocument, options);
      }
export function useGetSearchSiRnaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSearchSiRnaQuery, GetSearchSiRnaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSearchSiRnaQuery, GetSearchSiRnaQueryVariables>(GetSearchSiRnaDocument, options);
        }
export type GetSearchSiRnaQueryHookResult = ReturnType<typeof useGetSearchSiRnaQuery>;
export type GetSearchSiRnaLazyQueryHookResult = ReturnType<typeof useGetSearchSiRnaLazyQuery>;
export type GetSearchSiRnaQueryResult = ApolloReactCommon.QueryResult<GetSearchSiRnaQuery, GetSearchSiRnaQueryVariables>;
export const GetPriceSiRnaDocument = gql`
    query getPriceSiRNA($input: PriceInputSiRNA) {
  getPriceSiRNA(input: $input) {
    id
    price
    currency
    currencySymbol
    material
    serverError {
      key
      value
    }
  }
}
    `;
export type GetPriceSiRnaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPriceSiRnaQuery, GetPriceSiRnaQueryVariables>, 'query'>;

    export const GetPriceSiRnaComponent = (props: GetPriceSiRnaComponentProps) => (
      <ApolloReactComponents.Query<GetPriceSiRnaQuery, GetPriceSiRnaQueryVariables> query={GetPriceSiRnaDocument} {...props} />
    );
    

/**
 * __useGetPriceSiRnaQuery__
 *
 * To run a query within a React component, call `useGetPriceSiRnaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPriceSiRnaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPriceSiRnaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPriceSiRnaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPriceSiRnaQuery, GetPriceSiRnaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPriceSiRnaQuery, GetPriceSiRnaQueryVariables>(GetPriceSiRnaDocument, options);
      }
export function useGetPriceSiRnaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPriceSiRnaQuery, GetPriceSiRnaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPriceSiRnaQuery, GetPriceSiRnaQueryVariables>(GetPriceSiRnaDocument, options);
        }
export type GetPriceSiRnaQueryHookResult = ReturnType<typeof useGetPriceSiRnaQuery>;
export type GetPriceSiRnaLazyQueryHookResult = ReturnType<typeof useGetPriceSiRnaLazyQuery>;
export type GetPriceSiRnaQueryResult = ApolloReactCommon.QueryResult<GetPriceSiRnaQuery, GetPriceSiRnaQueryVariables>;
export const GetSemiConfSessionDataDocument = gql`
    query getSemiConfSessionData($product: SemiConfiguratorProductInput) {
  getSemiConfSessionData(product: $product) {
    term
    count
    pageNo
    stepNo
    perPage
    results {
      refseqId
      siRNAType
      species
      subSetInfo {
        siRNAId
        geneId
        geneSymbol
        refseqId
        species
        method
        sirnaProdType
        siRNAType
        siRNAAntiSenseSeq
        siRNASenseSeq
        fuzzyStart
        siRNATargetSeq
        fuzzyEnd
        ranking
        refseqStart
        refseqEnd
        price
        currency
        currencySymbol
        material
        brand
        checked
      }
    }
    selectedItems {
      refseqId
      siRNAType
      species
      subSetInfo {
        siRNAId
        geneId
        geneSymbol
        refseqId
        species
        method
        sirnaProdType
        siRNAType
        siRNAAntiSenseSeq
        siRNASenseSeq
        fuzzyStart
        siRNATargetSeq
        fuzzyEnd
        ranking
        refseqStart
        refseqEnd
        price
        currency
        currencySymbol
        material
        brand
        count
        purification
        size
      }
    }
    serverError {
      key
      value
    }
  }
}
    `;
export type GetSemiConfSessionDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSemiConfSessionDataQuery, GetSemiConfSessionDataQueryVariables>, 'query'>;

    export const GetSemiConfSessionDataComponent = (props: GetSemiConfSessionDataComponentProps) => (
      <ApolloReactComponents.Query<GetSemiConfSessionDataQuery, GetSemiConfSessionDataQueryVariables> query={GetSemiConfSessionDataDocument} {...props} />
    );
    

/**
 * __useGetSemiConfSessionDataQuery__
 *
 * To run a query within a React component, call `useGetSemiConfSessionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSemiConfSessionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSemiConfSessionDataQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetSemiConfSessionDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSemiConfSessionDataQuery, GetSemiConfSessionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSemiConfSessionDataQuery, GetSemiConfSessionDataQueryVariables>(GetSemiConfSessionDataDocument, options);
      }
export function useGetSemiConfSessionDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSemiConfSessionDataQuery, GetSemiConfSessionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSemiConfSessionDataQuery, GetSemiConfSessionDataQueryVariables>(GetSemiConfSessionDataDocument, options);
        }
export type GetSemiConfSessionDataQueryHookResult = ReturnType<typeof useGetSemiConfSessionDataQuery>;
export type GetSemiConfSessionDataLazyQueryHookResult = ReturnType<typeof useGetSemiConfSessionDataLazyQuery>;
export type GetSemiConfSessionDataQueryResult = ApolloReactCommon.QueryResult<GetSemiConfSessionDataQuery, GetSemiConfSessionDataQueryVariables>;
export const GetSubItemPriceSiRnaDocument = gql`
    query getSubItemPriceSiRNA($input: SubItemPriceInputSiRNA) {
  getSubItemPriceSiRNA(input: $input) {
    result {
      siRNAId
      siRNAType
      price
      currency
      currencySymbol
      checked
      purification
      size
      material
    }
  }
}
    `;
export type GetSubItemPriceSiRnaComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSubItemPriceSiRnaQuery, GetSubItemPriceSiRnaQueryVariables>, 'query'>;

    export const GetSubItemPriceSiRnaComponent = (props: GetSubItemPriceSiRnaComponentProps) => (
      <ApolloReactComponents.Query<GetSubItemPriceSiRnaQuery, GetSubItemPriceSiRnaQueryVariables> query={GetSubItemPriceSiRnaDocument} {...props} />
    );
    

/**
 * __useGetSubItemPriceSiRnaQuery__
 *
 * To run a query within a React component, call `useGetSubItemPriceSiRnaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubItemPriceSiRnaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubItemPriceSiRnaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSubItemPriceSiRnaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSubItemPriceSiRnaQuery, GetSubItemPriceSiRnaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSubItemPriceSiRnaQuery, GetSubItemPriceSiRnaQueryVariables>(GetSubItemPriceSiRnaDocument, options);
      }
export function useGetSubItemPriceSiRnaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSubItemPriceSiRnaQuery, GetSubItemPriceSiRnaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSubItemPriceSiRnaQuery, GetSubItemPriceSiRnaQueryVariables>(GetSubItemPriceSiRnaDocument, options);
        }
export type GetSubItemPriceSiRnaQueryHookResult = ReturnType<typeof useGetSubItemPriceSiRnaQuery>;
export type GetSubItemPriceSiRnaLazyQueryHookResult = ReturnType<typeof useGetSubItemPriceSiRnaLazyQuery>;
export type GetSubItemPriceSiRnaQueryResult = ApolloReactCommon.QueryResult<GetSubItemPriceSiRnaQuery, GetSubItemPriceSiRnaQueryVariables>;